export function formatPrice(price: number) {
  Math.round(price);

  const formattedPrice = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(price);

  return formattedPrice;
}

export function formatParcelPrice(parcelPrice: number) {
  const formattedPrice = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(parcelPrice / 12);

  return formattedPrice;
}
